import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Text,
  Icon,
  IconVariant,
  Image,
  DisplayPosition,
  Color,
} from '@gousto-internal/citrus-react'

import { TextBlock } from './TextBlock'
import { Tooltip, TooltipVariant, TooltipArrowType } from './Tooltip'
import { HOW_TO_MENU } from './data'

const RotatedImage = styled.div({
  transform: 'rotate(-8deg)',
})

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'nowrap',
  alignSelf: 'flex-end',
})

const TextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: 0,
  minWidth: '143px',
  marginLeft: '16px',

  '@media (min-width: 375px)': {
    minWidth: '182px',
  },

  '@media (min-width: 640px)': {
    marginLeft: '80px',
    minWidth: '362px',
  },
})

export const HowToSection = () => {
  const [swapIngredientsTooltipText] = HOW_TO_MENU.tooltips

  return (
    <Container data-testid="HowToSection">
      <Box display={Display.Flex} position={DisplayPosition.Relative}>
        <RotatedImage>
          <Image
            src={HOW_TO_MENU.imageSource}
            alt={HOW_TO_MENU.title}
            width="182px"
            height="371px"
          />
        </RotatedImage>
        <Box position={DisplayPosition.Absolute} right="0" top="260px">
          <Tooltip
            text={swapIngredientsTooltipText}
            variant={TooltipVariant.DARK}
            arrow={TooltipArrowType.RIGHT}
          />
        </Box>
      </Box>

      <TextContainer>
        <Box
          paddingBottom={2}
          position={[DisplayPosition.Relative, DisplayPosition.Unset]}
          right={['8px', '0']}
        >
          <TextBlock title={HOW_TO_MENU.title} text={HOW_TO_MENU.text} />
        </Box>

        {HOW_TO_MENU.bullets.map((bullet, index) => (
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Row}
            justifyContent={JustifyContent.FlexStart}
            alignItems={AlignItems.Center}
            key={`how-to-menu-bullet-${index + 1}`}
            position={[DisplayPosition.Relative, DisplayPosition.Unset]}
            left={['8px', '0']}
          >
            <Icon name="tick" variant={IconVariant.Confirmation} size={4} />
            <Text size={[1, 2]} color={Color.ColdGrey_800} style={{ fontWeight: 375 }}>
              {bullet}
            </Text>
          </Box>
        ))}
      </TextContainer>
    </Container>
  )
}
